import React from 'react';
import {Platform, StyleProp, Text, View, ViewStyle} from 'react-native';
import {LOADING_MESSAGE} from '../../../data/constants/paiement';
import {Loader} from '../../components/Loader';
import ConfirmationModal from '../Modal/ConfirmationModal';
import {styles} from './styles';

interface LoaderWithMessageProps {
  isLoading: boolean;
  message?: string;
  isModal?: boolean;
  title?: string;
  style?: StyleProp<ViewStyle>;
}
const LoaderWithMessage = ({
  isLoading,
  isModal = true,
  style,
  title = 'Information',
  message = `${LOADING_MESSAGE}.${
    Platform.OS === 'web'
      ? '\nVeuillez consulter votre téléphone pour valider la transaction.'
      : ''
  }`,
}: LoaderWithMessageProps) => {
  return (
    <View style={[styles.loaderWrapper, style]}>
      {isLoading ? (
        isModal ? (
          <ConfirmationModal
            title={title}
            content={message}
            children={<Loader />}
          />
        ) : (
          <View style={styles.loaderBody}>
            <Text style={[styles.modalText, styles.bold]}>{title}</Text>
            <Text style={[styles.modalText]}>{message}</Text>
            <Loader />
          </View>
        )
      ) : null}
    </View>
  );
};

export default LoaderWithMessage;
